import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import API from "../api";

export default function Login({setUser}) {
  const [form, setForm] = useState({
    email: "",
    password: ""
  });

  const navigate = useNavigate();
  //new change
  useEffect(() => {

  try {

    const user = localStorage.getItem("user");

    if (!user) return;

    const parsed = JSON.parse(user);

    if (parsed.role === "admin") {
      navigate("/home");
    } else {
      navigate("/dashboard");
    }

  } catch (err) {
    console.log(err);
    localStorage.clear();
  }

}, []);

  // 🔥 LOGIN
  const handleLogin = async () => {
    try {
      const res = await axios.post(
        `${API}/api/auth/login`,
        form
      );

      //update
      const userData = {
        ...res.data.user,
        personId: res.data.personId || res.data.user._id
      };

      localStorage.setItem("token", res.data.token);
      localStorage.setItem("user", JSON.stringify(userData));

      setUser(userData);
      // 🔥 ROLE BASED REDIRECT
      if (userData.role === "admin") {
        navigate("/home");
      } else {
        navigate("/dashboard");
      }

    } catch (err) {
      alert("Login failed");
    }
  };

  //new style
  return (
  <div className="min-h-screen flex items-center justify-center bg-[#f4f7fb] p-6">

    <div className="bg-white w-full max-w-md rounded-[35px] shadow-xl p-8">

      <h1 className="text-3xl font-bold mb-2">
        Welcome Back
      </h1>

      <p className="text-gray-500 mb-6">
        Login to continue
      </p>

      <input
        placeholder="Email"
        onChange={e => setForm({
          ...form,
          email: e.target.value
        })}
        className="input-modern mb-4"
      />

      <input
        type="password"
        placeholder="Password"
        onChange={e => setForm({
          ...form,
          password: e.target.value
        })}
        className="input-modern mb-6"
      />

      <button
        onClick={handleLogin}
        className="btn-primary w-full"
      >
        Login
      </button>

    </div>

  </div>
);
}